import React from 'react';
import ReactDOM from 'react-dom';
import './lib/i18n';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
